var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSweat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF0D74",
    d: "M15.205 6.429H12.96l-1.792 1.984l-1.046-1.984H7.791L4.714 9.84v.06l4.05 7.672h2.284l1.762-1.959l1.037 1.959h2.37l3.068-3.408zm-5.185 9.364l-2.97-5.627l1.8-1.993l2.965 5.623l-1.8 1.997zm5.112.06l-2.97-5.623l1.8-1.993l2.97 5.627z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSweat);
export default __webpack_public_path__ + "static/media/sweat.e20b220b8090fe61ee493b8b14c64a5d.svg";
export { ForwardRef as ReactComponent };